import React, { useState } from 'react';
import { string, func, bool, arrayOf } from 'prop-types';
import { FormattedMessage } from '../../../util/reactIntl';
import css from './SearchFiltersBar.module.css';

const CATEGORY_OPTIONS = [
  { value: 'archery', label: 'Archery' },
  { value: 'fishing', label: 'Fishing' },
  { value: 'hunting', label: 'Hunting/Outdoors' },
];

const SELLER_TYPE_OPTIONS = [
  { value: 'manufacturer', label: 'Manufacturers' },
  { value: 'owner', label: 'Dealer' },
  { value: 'innovator', label: 'Innovator' },
  { value: 'insider', label: 'Insider' },
  { value: 'independent', label: 'Peer' },
];

const CONDITION_OPTIONS = [
  { value: 'New', label: 'New' },
  { value: 'Used', label: 'Used' },
  { value: 'Open Box', label: 'Open Box' },
];

const SORT_OPTIONS = [
  { value: 'newest', label: 'Newest First' },
  { value: 'price-low', label: 'Price: Low to High' },
  { value: 'price-high', label: 'Price: High to Low' },
  { value: 'relevance', label: 'Relevance' },
];

const SearchFiltersBar = props => {
  const {
    sortValue,
    onSortChange,
    filterValue,
    onFilterChange,
    brandValue,
    onBrandChange,
    availableBrands,
    deliveryValue,
    onDeliveryChange,
    dealerValue,
    onDealerChange,
    onClearFilters,
    onKeywordSearch,
    sellerTypeValue,
    onSellerTypeChange,
    categoryValue,
    onCategoryChange,
    isMobile,
  } = props;

  const [searchKeyword, setSearchKeyword] = useState('');
  const [sellerTypeOpen, setSellerTypeOpen] = useState(!isMobile);
  const [conditionOpen, setConditionOpen] = useState(!isMobile);
  const [categoryOpen, setCategoryOpen] = useState(!isMobile);
  const [brandOpen, setBrandOpen] = useState(!isMobile);
  const [deliveryOpen, setDeliveryOpen] = useState(!isMobile);

  const DELIVERY_OPTIONS = [
    { value: 'pickup', label: 'Pickup' },
    { value: 'shipping', label: 'Shipping' },
  ];

  const selectedDelivery = deliveryValue ? deliveryValue.split(',') : [];
  const handleDeliveryChange = value => {
    const updated = selectedDelivery.includes(value)
      ? selectedDelivery.filter(v => v !== value)
      : [...selectedDelivery, value];
    onDeliveryChange(updated.join(','));
  };

  const selectedCategories = categoryValue ? categoryValue.split(',') : [];

  const handleCategoryChange = value => {
    const updated = selectedCategories.includes(value)
      ? selectedCategories.filter(v => v !== value)
      : [...selectedCategories, value];
    onCategoryChange(updated.join(','));
  };

  const selectedSellerTypes = sellerTypeValue ? sellerTypeValue.split(',') : [];

  const handleSellerTypeChange = value => {
    const updated = selectedSellerTypes.includes(value)
      ? selectedSellerTypes.filter(v => v !== value)
      : [...selectedSellerTypes, value];
    onSellerTypeChange(updated.join(','));
  };

  const selectedConditions = filterValue ? filterValue.split(',') : [];

  const handleConditionChange = value => {
    const updated = selectedConditions.includes(value)
      ? selectedConditions.filter(v => v !== value)
      : [...selectedConditions, value];
    onFilterChange(updated.join(','));
  };

  const handleKeywordSubmit = e => {
    e.preventDefault();
    if (onKeywordSearch) onKeywordSearch(searchKeyword);
  };

  return (
    <aside className={isMobile ? css.sidebarMobile : css.sidebar}>

      {/* Sort By */}
      <div className={css.sidebarSortBy}>
        <select
          value={sortValue}
          onChange={e => onSortChange(e.target.value)}
        >
          <option value="">Sort By</option>
          {SORT_OPTIONS.map(opt => (
            <option key={opt.value} value={opt.value}>{opt.label}</option>
          ))}
        </select>
      </div>

      {/* Keyword search */}
      <form className={css.sidebarSearch} onSubmit={handleKeywordSubmit}>
        <div className={css.sidebarSearchInputWrapper}>
          <input
            className={css.sidebarSearchInput}
            type="text"
            placeholder="Search these results"
            value={searchKeyword}
            onChange={e => setSearchKeyword(e.target.value)}
          />
          <svg className={css.sidebarSearchIcon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="11" cy="11" r="8" />
            <line x1="21" y1="21" x2="16.65" y2="16.65" />
          </svg>
        </div>
        <button type="submit" className={css.sidebarSearchButton}>
          Search
        </button>
      </form>

      {/* Seller Type */}
      {/* <div className={css.filterSection}>
        <button className={css.filterSectionHeader} onClick={() => setSellerTypeOpen(prev => !prev)}>
          <h3 className={css.filterSectionTitle}>Seller Type</h3>
          <span className={css.filterToggle}>{sellerTypeOpen ? '−' : '+'}</span>
        </button>
        {sellerTypeOpen && (
          <div className={css.checkboxGroup}>
            {SELLER_TYPE_OPTIONS.map(opt => (
              <label key={opt.value} className={css.checkboxLabel}>
                <input
                  type="checkbox"
                  className={css.checkboxInput}
                  checked={selectedSellerTypes.includes(opt.value)}
                  onChange={() => handleSellerTypeChange(opt.value)}
                />
                <span className={css.customCheckbox} />
                {opt.label}
              </label>
            ))}
          </div>
        )}
      </div> */}

      {/* Interest Area */}
      <div className={css.filterSection}>
        <button className={css.filterSectionHeader} onClick={() => isMobile && setCategoryOpen(prev => !prev)}>
          <h3 className={css.filterSectionTitle}>Interest Area</h3>
          {isMobile && <span className={css.filterToggle}>{categoryOpen ? '−' : '+'}</span>}
        </button>
        {(!isMobile || categoryOpen) && (
          <div className={css.checkboxGroup}>
            {CATEGORY_OPTIONS.map(opt => (
              <label key={opt.value} className={css.checkboxLabel}>
                <input
                  type="checkbox"
                  className={css.checkboxInput}
                  checked={selectedCategories.includes(opt.value)}
                  onChange={() => handleCategoryChange(opt.value)}
                />
                <span className={css.customCheckbox} />
                {opt.label}
              </label>
            ))}
          </div>
        )}
      </div>

      {/* Brand */}
      {availableBrands && availableBrands.length > 0 && (
        <div className={css.filterSection}>
          <button className={css.filterSectionHeader} onClick={() => isMobile && setBrandOpen(prev => !prev)}>
            <h3 className={css.filterSectionTitle}>Brand</h3>
            {isMobile && <span className={css.filterToggle}>{brandOpen ? '−' : '+'}</span>}
          </button>
          {(!isMobile || brandOpen) && (
            <div className={css.checkboxGroupScrollable}>
              {availableBrands.map(brand => {
                const selectedBrands = brandValue ? brandValue.split(',') : [];
                const isChecked = selectedBrands.includes(brand);
                const handleChange = () => {
                  const updated = isChecked
                    ? selectedBrands.filter(b => b !== brand)
                    : [...selectedBrands, brand];
                  onBrandChange(updated.join(','));
                };
                return (
                  <label key={brand} className={css.checkboxLabel} onMouseDown={e => e.preventDefault()}>
                    <input
                      type="checkbox"
                      className={css.checkboxInput}
                      checked={isChecked}
                      onChange={handleChange}
                      onFocus={e => { const y = window.scrollY; e.target.blur(); window.scrollTo(0, y); }}
                    />
                    <span className={css.customCheckbox} />
                    {brand}
                  </label>
                );
              })}
            </div>
          )}
        </div>
      )}

      {/* Condition */}
      <div className={css.filterSection}>
        <button className={css.filterSectionHeader} onClick={() => isMobile && setConditionOpen(prev => !prev)}>
          <h3 className={css.filterSectionTitle}>
            <FormattedMessage id="SearchFiltersBar.filters" />
          </h3>
          {isMobile && <span className={css.filterToggle}>{conditionOpen ? '−' : '+'}</span>}
        </button>
        {(!isMobile || conditionOpen) && (
          <div className={css.checkboxGroup}>
            {CONDITION_OPTIONS.map(opt => (
              <label key={opt.value} className={css.checkboxLabel}>
                <input
                  type="checkbox"
                  className={css.checkboxInput}
                  checked={selectedConditions.includes(opt.value)}
                  onChange={() => handleConditionChange(opt.value)}
                />
                <span className={css.customCheckbox} />
                {opt.label}
              </label>
            ))}
          </div>
        )}
      </div>

      {/* Delivery */}
      <div className={css.filterSection}>
        <button className={css.filterSectionHeader} onClick={() => isMobile && setDeliveryOpen(prev => !prev)}>
          <h3 className={css.filterSectionTitle}>Delivery</h3>
          {isMobile && <span className={css.filterToggle}>{deliveryOpen ? '−' : '+'}</span>}
        </button>
        {(!isMobile || deliveryOpen) && (
          <div className={css.checkboxGroup}>
            {DELIVERY_OPTIONS.map(opt => (
              <label key={opt.value} className={css.checkboxLabel}>
                <input
                  type="checkbox"
                  className={css.checkboxInput}
                  checked={selectedDelivery.includes(opt.value)}
                  onChange={() => handleDeliveryChange(opt.value)}
                />
                <span className={css.customCheckbox} />
                {opt.label}
              </label>
            ))}
          </div>
        )}
      </div>

      <button className={css.resetAllButton} onClick={onClearFilters}>
        Reset all filters
      </button>

    </aside>
  );
};

SearchFiltersBar.defaultProps = {
  sortValue: '',
  filterValue: '',
  brandValue: '',
  availableBrands: [],
  deliveryValue: '',
  sellerTypeValue: '',
  categoryValue: '',
  isMobile: false,
};

SearchFiltersBar.propTypes = {
  sortValue: string,
  onSortChange: func.isRequired,
  filterValue: string,
  onFilterChange: func.isRequired,
  brandValue: string,
  onBrandChange: func.isRequired,
  availableBrands: arrayOf(string),
  deliveryValue: string,
  onDeliveryChange: func.isRequired,
  dealerValue: string,
  onDealerChange: func.isRequired,
  onClearFilters: func.isRequired,
  onKeywordSearch: func,
  sellerTypeValue: string,
  onSellerTypeChange: func.isRequired,
  categoryValue: string,
  onCategoryChange: func.isRequired,
  isMobile: bool,
};

export default SearchFiltersBar;
